<template>
  <div class="w-100 bg-white">
    <Header></Header>
    
    <!-- NAME & SLIDER -->
    <div class="pt-5">
      <div class="px-10 d-block pt-5">
        <div class="w-100" v-if="data_parent.is_load">
					<b-row class="slim-grid-row mb-2">
						<b-col cols="12" class="mb-2">
							<b-skeleton width="40%" height="56px"></b-skeleton>
						</b-col>
						<b-col cols="2">
							<b-skeleton width="100%" height="30px"></b-skeleton>
						</b-col>
						<b-col cols="4">
							<b-skeleton width="100%" height="30px"></b-skeleton>
						</b-col>
					</b-row>
					<b-row class="slim-grid-row">
						<b-col cols="8">
							<b-skeleton width="100%" height="400px"></b-skeleton>
						</b-col>
						<b-col cols="4">
							<b-row class="slim-grid-row">
								<b-col cols="6" class="mb-2">
									<b-skeleton width="100%" height="192px" class="mb-0"></b-skeleton>
								</b-col>
								<b-col cols="6" class="mb-2">
									<b-skeleton width="100%" height="192px" class="mb-0"></b-skeleton>
								</b-col>
								<b-col cols="12" class="mt-2">
									<b-skeleton width="100%" height="192px" class="mb-0"></b-skeleton>
								</b-col>
							</b-row>
						</b-col>
					</b-row>
				</div>
        
        <template v-else>
          <!-- NAME & ADDRESS -->
          <div class="row">
            <div class="col-10 align-self-end">
              <h1 class="mb-1 pt-3 heading-4-1 text-34 font-extrabold">{{getMerchant.name}}</h1>
              <div class="w-100 no-ws" v-if="$isNotEmpty(data_parent.merchant_area)">
                <svg class="d-inline-block align-middle lh-1 mr-2" width="18" height="18" viewBox="0 0 18 18" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M2.625 7.73832C2.625 4.28842 5.50791 1.5 8.99508 1.5C12.4921 1.5 15.375 4.28842 15.375 7.73832C15.375 9.47677 14.7428 11.0907 13.7021 12.4587C12.5541 13.9676 11.1391 15.2823 9.54641 16.3143C9.18188 16.5528 8.85291 16.5708 8.45284 16.3143C6.85105 15.2823 5.43607 13.9676 4.29787 12.4587C3.25649 11.0907 2.625 9.47677 2.625 7.73832ZM6.89567 7.93256C6.89567 9.08828 7.83874 9.99725 8.99508 9.99725C10.1522 9.99725 11.1043 9.08828 11.1043 7.93256C11.1043 6.78585 10.1522 5.83262 8.99508 5.83262C7.83874 5.83262 6.89567 6.78585 6.89567 7.93256Z"
                    fill="#222222" />
                </svg>
                <p class="mb-0 body-2-2 text-16 font-medium d-inline-block align-middle">{{data_parent.merchant_area}}</p>
              </div>
            </div>
            <div class="col-2 align-self-end">
              <div class="no-ws d-table ml-auto menu-hover-bottom cursor-pointer" @click="shareClick">
                <div class="d-inline-block align-middle">
                  <svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_356_36)">
                      <path
                        d="M2.77979 21.3353H12.934C14.7842 21.3353 15.7138 20.4146 15.7138 18.591V9.75585C15.7138 7.93214 14.7842 7.01144 12.934 7.01144H2.77979C0.929548 7.01144 0 7.93214 0 9.75585V18.591C0 20.4146 0.929548 21.3353 2.77979 21.3353ZM1.42531 18.5113V9.83547C1.42531 8.91481 1.91221 8.43677 2.79749 8.43677H12.9074C13.7839 8.43677 14.2885 8.91481 14.2885 9.83547V18.5113C14.2885 19.432 13.7839 19.91 12.9074 19.91H2.79749C1.91221 19.91 1.42531 19.432 1.42531 18.5113Z"
                        class="menu-hover-bottom-icon" />
                      <path
                        d="M10.2693 13.713V2.39912C10.2693 1.08005 9.18035 0 7.85244 0C6.53339 0 5.44449 1.08005 5.44449 2.39912V13.713C5.44449 15.0232 6.53339 16.1121 7.85244 16.1121C9.18035 16.1121 10.2693 15.0232 10.2693 13.713Z"
                        fill="white" />
                      <path
                        d="M7.85244 14.4036C8.2331 14.4036 8.56066 14.0848 8.56066 13.713V4.62118L8.50755 3.29326L9.10073 3.92181L10.4463 5.35596C10.5703 5.49761 10.7474 5.56843 10.9244 5.56843C11.2874 5.56843 11.5706 5.30284 11.5706 4.93988C11.5706 4.75397 11.4909 4.61233 11.3582 4.47953L8.36591 1.59351C8.18883 1.41645 8.03835 1.35448 7.85244 1.35448C7.67544 1.35448 7.52491 1.41645 7.33899 1.59351L4.34674 4.47953C4.21394 4.61233 4.14313 4.75397 4.14313 4.93988C4.14313 5.30284 4.40871 5.56843 4.78052 5.56843C4.94873 5.56843 5.14349 5.49761 5.26744 5.35596L6.60421 3.92181L7.2062 3.29326L7.15309 4.62118V13.713C7.15309 14.0848 7.47178 14.4036 7.85244 14.4036Z"
                        class="menu-hover-bottom-icon" />
                    </g>
                    <defs>
                      <clipPath id="clip0_356_36">
                        <rect width="15.7138" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <p class="mb-0 body-1-2 d-inline-block align-middle ml-2">Share</p>
              </div>
            </div>
          </div>
          
          <!-- SLIDER -->
          <div class="mt-3" v-if="getMerchant.merchant_images.length > 0">
            <div class="row slim-grid-row-1">
              <div class="col-12" v-if="getMerchant.merchant_images.length < 4">
                <div v-if="getMerchant.merchant_images.length == 1" class="w-100 h-400">
                  <img :src="getMerchant.merchant_images[0].image_url" class="img-fit cursor-pointer h-400 radius-8"
                    :alt="getMerchant.name">
                </div>
                <flickity v-else ref="flickity" :options="$fullSliderOption">
                  <div class="carousel-cell w-100" :id="slider_merchant.id"
                    v-for="(slider_merchant,index) in  getMerchant.merchant_images">
                    <div class="w-100 h-400">
                      <img @click="setActiveImage(index)" :src="slider_merchant.image_url" class="img-fit h-400 radius-8 cursor-pointer"
                        :alt="getMerchant.name">
                    </div>
                  </div>
                </flickity>
              </div>
              <template v-else>
                <div class="col-8">
                  <img 
                    @click="setActiveImage(0)"
                    :src="getMerchant.merchant_images[0].image_url" class="w-100 img-slider-1 h-400 cursor-pointer"
                    :alt="getMerchant.name">
                </div>
                <div class="col-4 h-400 overflow-hidden">
                  <div class="row slim-grid-row-1">
                    <div class="col-12 mb-2">
                      <div class="row slim-grid-row-1">
                        <div class="col-6">
                          <img @click="setActiveImage(1)" :src="getMerchant.merchant_images[1].image_url" class="w-100 img-slider-2 cursor-pointer"
                            :alt="getMerchant.name">
                        </div>
                        <div class="col-6">
                          <img @click="setActiveImage(2)" :src="getMerchant.merchant_images[2].image_url" class="w-100 img-slider-3 cursor-pointer"
                            :alt="getMerchant.name">
                        </div>
                      </div>
                    </div>
                    <div class="col-12 position-relative">
                      <img @click="setActiveImage(3)" :src="getMerchant.merchant_images[3].image_url" class="w-100 img-slider-4 cursor-pointer"
                        :alt="getMerchant.name">
                      <button v-if="getMerchant.merchant_images.length > 4" type="button" @click="setActiveImage(4)"
                        class="g-btn bg-white g-btn-sm position-absolute bottom-0 right-0 px-3 cursor-pointer"
                        style="bottom: 18px;right: 24px;">View More</button>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
  
          <CoolLightBox 
            :items="getMerchant.merchant_images" 
            srcName="image_url" 
            :index="active_image"
            @close="active_image = null">
          </CoolLightBox>
        </template>
      </div>
    </div>

    <div class="px-10 mt-5 mb-5">
      <div class="w-100">
        <div class="row no-gutters">
          <div class="col-7">
            <div class="w-100 mb-5" v-if="data_parent.is_load">
              <b-skeleton width="100%" height="20px" class="mb-1"></b-skeleton>
              <b-skeleton width="100%" height="20px" class="mb-1"></b-skeleton>
              <b-skeleton width="50%" height="20px" class="mb-5"></b-skeleton>
              <b-skeleton width="20%" height="30px" class="mb-2"></b-skeleton>
              <b-skeleton width="70%" height="20px" class="mb-2"></b-skeleton>
              <b-skeleton width="50%" height="20px"></b-skeleton>
            </div>
            <template v-else>
              <!-- DESCRIPTION -->
              <div class="body-1-2 html-desc mb-5" v-html="getMerchant.description"></div>
  
              <!-- GENERAL INFORMATION -->
              <div class="w-100 border-b-semi-grey mb-5 pb-5">
                <p class="mb-4 heading-4-1">Experience</p>
                <div class="w-100 mb-4 border-b-semi-grey pb-4" v-if="$isNotEmpty(getMerchant.highlights)">
                  <p class="mb-2 sub-heading-1-2">Highlights</p>
                  <div class="body-2-2 html-desc" v-html="getMerchant.highlights"></div>
                </div>
                <div class="w-100 mb-4 border-b-semi-grey pb-4" v-if="$isNotEmpty(getMerchant.experience)">
                  <p class="mb-2 sub-heading-1-2">What You'll Experience</p>
                  <div class="body-2-2 html-desc" v-html="getMerchant.experience"></div>
                </div>
                <div class="w-100 mb-4 border-b-semi-grey pb-4" v-if="getMerchant.facilities.length > 0">
                  <p class="mb-2 sub-heading-1-2">Facilities</p>
                  <div class="row slim-grid-row">
                    <div class="col-2 text-center mb-3" v-for="fac in getMerchant.facilities">
                      <div class="w-100 radius-6 border-semi-grey h-100 py-3">
                        <i :class="fac.icon" class="text-20 font-weight-bold text-green"></i>
                        <p class="body-p pt-1 mb-0">{{fac.name}}</p>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="body-2-2 html-desc" v-html="getMerchant.experience"></div> -->
                </div>
                <div class="w-100 mb-4 border-b-semi-grey pb-4" v-if="$isNotEmpty(getMerchant.terms_and_conditions)">
                  <p class="mb-2 sub-heading-1-2">Terms & Conditions</p>
                  <div class="body-2-2 html-desc" v-html="getMerchant.terms_and_conditions"></div>
                </div>
                <div class="w-100" v-if="$isNotEmpty(getMerchant.cancellation_policy)">
                  <p class="mb-2 sub-heading-1-2">Cancellation Policy</p>
                  <div class="body-2-2 html-desc" v-html="getMerchant.cancellation_policy"></div>
                </div>
              </div>
  
              <!-- LOCATION -->
              <div class="w-100 border-b-semi-grey mb-5 pb-5">
                <div class="w-100 mb-2">
                  <p class="mb-1 heading-4-1">Location Detail</p>
                  <div class="w-100 no-ws">
                    <svg class="d-inline-block align-middle lh-1 mr-2" width="18" height="18" viewBox="0 0 18 18" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M2.625 7.73832C2.625 4.28842 5.50791 1.5 8.99508 1.5C12.4921 1.5 15.375 4.28842 15.375 7.73832C15.375 9.47677 14.7428 11.0907 13.7021 12.4587C12.5541 13.9676 11.1391 15.2823 9.54641 16.3143C9.18188 16.5528 8.85291 16.5708 8.45284 16.3143C6.85105 15.2823 5.43607 13.9676 4.29787 12.4587C3.25649 11.0907 2.625 9.47677 2.625 7.73832ZM6.89567 7.93256C6.89567 9.08828 7.83874 9.99725 8.99508 9.99725C10.1522 9.99725 11.1043 9.08828 11.1043 7.93256C11.1043 6.78585 10.1522 5.83262 8.99508 5.83262C7.83874 5.83262 6.89567 6.78585 6.89567 7.93256Z"
                        fill="#222222" />
                    </svg>
                    <p class="mb-0 body-2-2 text-16 font-medium d-inline-block align-middle">{{getMerchant.address}}</p>
                  </div>
                </div>
                <div class="w-100">
                  <ShowGmaps/>
                </div>
              </div>
  
              <!-- TICKET OPTIONS -->
              <div class="w-100 pb-5" :class="{'border-b-semi-grey mb-5': show_review}" id="ticket-option">
                <p class="mb-4 heading-4-1">Ticket Options</p>
                <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey">
                  <!-- ACTIVITIES -->
                  <div class="p-4" v-if="getMerchant.merchant_category_name == 'ACTIVITIES'">
                    <div class="w-100 pb-4 mb-4 border-2-bottom-dashed">
                      <date-range-picker 
                        :disabled="data_parent.product.is_load"
                        class="w-100 calendar-ticket-wrapper not-zoo z-index-1039" 
                        ref="date" 
                        v-model="visit_date"
                        opens="right" 
                        :min-date="min_date"
                        :show-dropdowns="false" 
                        :ranges="false" 
                        :single-date-picker="true" 
                        auto-apply>
                        <template v-slot:input="picker">
                          <div class="w-100">
                            <div class="row no-gutters">
                              <div class="col-9 text-left align-self-center no-ws">
                                <div class="d-inline-block align-middle mr-3 ml-2">
                                  <svg width="29" height="27" viewBox="0 0 29 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.53195 26.6H24.2474C27.2638 26.6 28.7649 25.0989 28.7649 22.1257V4.50307C28.7649 1.52989 27.2638 0.0288544 24.2474 0.0288544H4.53195C1.51546 0.0288544 0 1.51545 0 4.50307V22.1257C0 25.1133 1.51546 26.6 4.53195 26.6ZM4.31546 24.2762C3.03092 24.2762 2.32371 23.5979 2.32371 22.2556V8.64533C2.32371 7.3175 3.03092 6.62472 4.31546 6.62472H24.4349C25.7195 6.62472 26.4412 7.3175 26.4412 8.64533V22.2556C26.4412 23.5979 25.7195 24.2762 24.4349 24.2762H4.31546ZM11.5752 11.8062H12.4267C12.9319 11.8062 13.0907 11.6618 13.0907 11.1567V10.3051C13.0907 9.79997 12.9319 9.6412 12.4267 9.6412H11.5752C11.0701 9.6412 10.8969 9.79997 10.8969 10.3051V11.1567C10.8969 11.6618 11.0701 11.8062 11.5752 11.8062ZM16.367 11.8062H17.2186C17.7236 11.8062 17.8968 11.6618 17.8968 11.1567V10.3051C17.8968 9.79997 17.7236 9.6412 17.2186 9.6412H16.367C15.8618 9.6412 15.6887 9.79997 15.6887 10.3051V11.1567C15.6887 11.6618 15.8618 11.8062 16.367 11.8062ZM21.1587 11.8062H22.0103C22.5154 11.8062 22.6886 11.6618 22.6886 11.1567V10.3051C22.6886 9.79997 22.5154 9.6412 22.0103 9.6412H21.1587C20.6535 9.6412 20.4948 9.79997 20.4948 10.3051V11.1567C20.4948 11.6618 20.6535 11.8062 21.1587 11.8062ZM6.78349 16.5258H7.6206C8.1402 16.5258 8.29895 16.3814 8.29895 15.8762V15.0247C8.29895 14.5196 8.1402 14.3752 7.6206 14.3752H6.78349C6.26391 14.3752 6.10514 14.5196 6.10514 15.0247V15.8762C6.10514 16.3814 6.26391 16.5258 6.78349 16.5258ZM11.5752 16.5258H12.4267C12.9319 16.5258 13.0907 16.3814 13.0907 15.8762V15.0247C13.0907 14.5196 12.9319 14.3752 12.4267 14.3752H11.5752C11.0701 14.3752 10.8969 14.5196 10.8969 15.0247V15.8762C10.8969 16.3814 11.0701 16.5258 11.5752 16.5258ZM16.367 16.5258H17.2186C17.7236 16.5258 17.8968 16.3814 17.8968 15.8762V15.0247C17.8968 14.5196 17.7236 14.3752 17.2186 14.3752H16.367C15.8618 14.3752 15.6887 14.5196 15.6887 15.0247V15.8762C15.6887 16.3814 15.8618 16.5258 16.367 16.5258ZM21.1587 16.5258H22.0103C22.5154 16.5258 22.6886 16.3814 22.6886 15.8762V15.0247C22.6886 14.5196 22.5154 14.3752 22.0103 14.3752H21.1587C20.6535 14.3752 20.4948 14.5196 20.4948 15.0247V15.8762C20.4948 16.3814 20.6535 16.5258 21.1587 16.5258ZM6.78349 21.2597H7.6206C8.1402 21.2597 8.29895 21.101 8.29895 20.5959V19.7442C8.29895 19.2391 8.1402 19.0948 7.6206 19.0948H6.78349C6.26391 19.0948 6.10514 19.2391 6.10514 19.7442V20.5959C6.10514 21.101 6.26391 21.2597 6.78349 21.2597ZM11.5752 21.2597H12.4267C12.9319 21.2597 13.0907 21.101 13.0907 20.5959V19.7442C13.0907 19.2391 12.9319 19.0948 12.4267 19.0948H11.5752C11.0701 19.0948 10.8969 19.2391 10.8969 19.7442V20.5959C10.8969 21.101 11.0701 21.2597 11.5752 21.2597ZM16.367 21.2597H17.2186C17.7236 21.2597 17.8968 21.101 17.8968 20.5959V19.7442C17.8968 19.2391 17.7236 19.0948 17.2186 19.0948H16.367C15.8618 19.0948 15.6887 19.2391 15.6887 19.7442V20.5959C15.6887 21.101 15.8618 21.2597 16.367 21.2597Z" class="fill-primary"/>
                                  </svg>
                                </div>
                                <div class="d-inline-block align-middle">
                                  <p class="overline mb-0 text-uppercase">{{ $t('ticket.visit-date') }}</p>
                                  <p class="sub-heading-1-2 text-green mb-0">{{ $formatDate(visit_date.startDate) }}</p>
                                </div>
                              </div>
                              <div class="col-3 text-right align-self-center">
                                <button class="g-btn g-btn-primary g-btn-lg w-100">{{ $t('ticket.change-date') }}</button>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template #date="data">
                          <div class="calendar-ticket-item">
                            <p class="text-14 font-lato mb-0">
                              {{ formatDateNumber(data.date) }}
                            </p>
                          </div>
                        </template>
                      </date-range-picker>
  
                      <div class="w-100 position-relative mt-4" v-if="data_parent.product_special.length > 0">
                        <div class="w-100 py-2 radius-6 cursor-pointer" v-for="(ps,ps_i) in data_parent.product_special"
                          @click="toggleProductSpecial(ps)"
                          :class="
                          {
                            'border-green bg-green-light-2': ps.id == product_special_selected.id,
                            'border-form': ps.id != product_special_selected.id,
                            'mb-3': ps_i+1 < data_parent.product_special.length
                          }">
                          <div class="row no-gutters">
                            <div class="col-lg-1 col-2 align-self-center">
                              <div v-if="data_parent.product_special.length > 1" class="radio-button mx-auto d-table">
                                <div class="active" v-if="ps.id == product_special_selected.id"></div>
                              </div>
                              <div v-else class="checkbox-button mx-auto d-table text-center lh-1" :class="ps.id == product_special_selected.id?'active':''">
                                <svg class="lh-1 align-baseline" width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4.62233 8.65556L1.3271 5.36034L0.204987 6.47455L4.62233 10.8919L14.105 1.40923L12.9908 0.295013L4.62233 8.65556Z" fill="white"/>
                                </svg>
                              </div>
                            </div>
                            <div class="col-lg-9 col-7 align-self-center">
                              <p class="mb-0 body-2-4 text-ticket">{{ ps.name }}</p>
                              <div class="body-3-3-1 html-desc" v-html="ps.description"></div>
                            </div>
                            <div class="col-lg-2 col-3 align-self-center">
                              <div class="px-3 text-right">
                                <img v-if="!$isImageNull(ps.image_url)" class="w-75" :src="ps.image_url">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-100">
                      <b-skeleton-wrapper :loading="data_parent.product.is_load">
                        <template #loading>
                          <div class="mb-4 border-form radius-6" v-for="i in 2">
                            <div class="row">
                              <div class="col-9 align">
                                <div class="py-4 pl-4 h-100">
                                  <b-skeleton width="50%" height="27px"></b-skeleton>
                                  <div class="my-2">
                                    <b-skeleton width="30%" height="21px" class="mb-1"></b-skeleton>
                                    <b-skeleton width="70%" height="21px"></b-skeleton>
                                  </div>
                                  <b-skeleton width="20%" height="18px" class="d-table ml-auto"></b-skeleton>
                                </div>
                              </div>
                              <div class="col-3">
                                <div class="p-4 h-100 text-center bg-custom-light">
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                      
                        <div class="w-100">
                          <div class="mb-4" v-for="product in data_parent.product.list">
                            <Product :data="product"></Product>
                          </div>
                        </div>
                      </b-skeleton-wrapper>
                    </div>
                  </div>

                  <!-- TRANSPORT -->
                  <template v-else-if="getMerchant.merchant_category_name == 'TRANSPORT'">
                    <div class="w-100 p-4 bg-light-page mb-4 border-b-form">
                      <div class="row">
                        <template v-if="!minimize_transport_filter">
                          <!-- FROM -->
                          <div class="col-6 border-r-semi-grey">
                            <b-dropdown id="filter_form" variant="link" toggle-class="text-decoration-none p-0 no-bs" no-caret block menu-class="w-100 dd-transport-filter z-index-1041" no-flip>
                              <template #button-content>
                                <div class="row no-gutters">
                                  <div class="col-1 align-self-center">
                                    <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g clip-path="url(#clip0_365_13)">
                                        <path
                                          d="M0.0804538 19.5214L0.904224 22.3471C1.05748 22.8357 1.25863 23.1901 1.52684 23.4487L2.77208 22.6345C2.43682 22.5004 2.21651 22.2322 2.09199 21.7916L1.45021 19.4161C1.40232 19.2628 1.45979 19.1575 1.62263 19.1575H20.2053C20.3682 19.1575 20.4161 19.2916 20.3011 19.4161L18.2322 21.782C17.9065 22.1461 17.6478 22.4526 17.0731 22.6154L18.2417 23.4775C18.7399 23.1327 19.123 22.6537 19.6211 22.0885L21.69 19.713C22.3702 18.918 21.8721 17.8548 20.7705 17.8548H1.29695C0.252871 17.8548 -0.197329 18.5636 0.0804538 19.5214ZM9.19942 18.6593H10.4925V0.651354C10.4925 0.29694 10.1956 0 9.84115 0C9.48673 0 9.19942 0.29694 9.19942 0.651354V18.6593ZM9.93695 15.3643H13.8738C16.757 15.3643 18.3567 13.8892 18.3567 11.504C18.3567 7.44268 14.1421 2.87362 10.2148 0.823769L9.55384 1.94449C12.8105 3.36213 17.0636 7.61509 17.0636 11.3029C17.0636 12.9696 15.895 14.0616 13.8834 14.0616H9.93695V15.3643ZM10.7416 2.54794C13.9217 7.10742 12.8968 12.6535 9.88905 14.1766L10.1573 15.3068C14.2666 13.4198 15.2436 7.46183 11.8527 2.35637L10.7416 2.54794ZM2.39851 15.3643H9.69754V14.0616H3.64374C3.5288 14.0616 3.4809 13.9466 3.57669 13.8796C6.85261 11.4082 9.87949 5.7185 10.3776 1.81996L9.19942 1.00577C9.27601 4.2338 6.25873 10.3738 1.8621 13.5635C0.932963 14.2436 1.45021 15.3643 2.39851 15.3643ZM10.1477 24.4832C12.7531 24.4832 13.1746 22.5387 14.688 22.5387C16.2494 22.5387 16.4984 24.4832 19.4869 24.4832H20.4544C20.828 24.4832 21.1345 24.1767 21.1345 23.8032C21.1345 23.4296 20.828 23.1327 20.4544 23.1327H19.4869C18.4525 23.1327 17.8778 22.7016 17.1497 22.1939C16.5271 21.7438 15.7513 21.1882 14.688 21.1882C13.5961 21.1882 12.8105 21.7724 12.1784 22.2418C11.527 22.7399 11.0002 23.1327 10.1477 23.1327C9.28558 23.1327 8.75877 22.7399 8.10743 22.2418C7.47523 21.7724 6.68978 21.1882 5.5978 21.1882C4.53457 21.1882 3.75869 21.7438 3.13607 22.1939C2.40808 22.7016 1.83336 23.1327 0.798859 23.1327H0.750965C0.377395 23.1327 0.0804538 23.4296 0.0804538 23.8032C0.0804538 24.1767 0.377395 24.4832 0.750965 24.4832H0.798859C3.78742 24.4832 4.03647 22.5387 5.5978 22.5387C7.11124 22.5387 7.53271 24.4832 10.1477 24.4832Z"
                                          fill="black" fill-opacity="0.85" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_365_13">
                                          <rect width="22" height="24.9526" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </div>
                                  <div class="col-10 align-self-center text-left">
                                    <div class="px-2">
                                      <p class="mb-0 body-3-3-2">From</p>
                                      <p class="mb-0 body-2-2" v-if="data_parent.transport_route.from.selected.id">{{ data_parent.transport_route.from.selected.name }}</p>
                                      <p class="mb-0 body-2-2-1" v-else><i>Select Harbor</i></p>
                                    </div>
                                  </div>  
                                  <div class="col-1 align-self-center text-right">
                                    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g clip-path="url(#clip0_366_21)">
                                        <path
                                          d="M10 0.766817C10 0.301699 9.64177 0.012572 9.09491 0.012572L0.898807 0.00628662C0.35198 0.00628662 0 0.295413 0 0.760531C0 1.01195 0.113137 1.21936 0.238844 1.48334L4.16091 9.56003C4.4249 10.0943 4.66374 10.264 4.99687 10.264C5.32999 10.264 5.5751 10.0943 5.83909 9.56003L9.75489 1.48334C9.88688 1.22565 10 1.01823 10 0.766817Z"
                                          fill="black" fill-opacity="0.85" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_366_21">
                                          <rect width="10" height="10.264" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </div>
                                </div>
                              </template>
                              <b-dropdown-group v-for="(area,area_i) in data_parent.transport_route.from.list" :header="area.name" header-classes="body-3 text-12 border-none" :class="{'border-b-form' : area_i+1 < data_parent.transport_route.from.list.length}" :key="area_i">
                                <b-dropdown-item v-for="(harbor,harbor_i) in area.child" :active="harbor.id == data_parent.transport_route.from.selected.id" @click="selectTransportFilter('from',area_i,harbor_i)" link-class="body-2-2 py-2 pl-4-5" :key="harbor_i">{{ harbor.name }}</b-dropdown-item>
                              </b-dropdown-group>
                            </b-dropdown>
                          </div>
    
                          <!-- TO -->
                          <div class="col-6 border-l-semi-grey">
                            <b-dropdown :disabled="!data_parent.transport_route.from.selected.id" ref="filter_to" id="filter_to" variant="link" toggle-class="text-decoration-none p-0 no-bs" no-caret block no-flip menu-class="w-100 dd-transport-filter z-index-1041" >
                              <template #button-content>
                                <div class="row no-gutters">
                                  <div class="col-1 align-self-center">
                                    <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g clip-path="url(#clip0_365_13)">
                                        <path
                                          d="M21.9195 19.0233L21.0958 21.7769C20.9425 22.2529 20.7414 22.5983 20.4732 22.8503L19.2279 22.0569C19.5632 21.9262 19.7835 21.6649 19.908 21.2355L20.5498 18.9206C20.5977 18.7713 20.5402 18.6686 20.3774 18.6686H1.79465C1.63183 18.6686 1.58393 18.7993 1.69885 18.9206L3.76782 21.2261C4.09355 21.5809 4.35217 21.8796 4.92687 22.0383L3.75826 22.8784C3.26014 22.5423 2.87703 22.0756 2.37892 21.5248L0.309953 19.21C-0.370193 18.4352 0.127921 17.3992 1.22951 17.3992H20.703C21.7471 17.3992 22.1973 18.0898 21.9195 19.0233ZM12.8006 18.1832H11.5075V0.634732C11.5075 0.289363 11.8044 0 12.1588 0C12.5133 0 12.8006 0.289363 12.8006 0.634732V18.1832ZM12.0631 14.9722H8.1262C5.24295 14.9722 3.64333 13.5347 3.64333 11.2105C3.64333 7.25274 7.85793 2.80028 11.7852 0.802747L12.4462 1.89486C9.18945 3.27633 4.93643 7.42076 4.93643 11.0144C4.93643 12.6386 6.10505 13.7027 8.11663 13.7027H12.0631V14.9722ZM11.2584 2.48292C8.0783 6.92604 9.10322 12.3306 12.1109 13.8148L11.8427 14.9162C7.73344 13.0774 6.75642 7.27141 10.1473 2.29623L11.2584 2.48292ZM19.6015 14.9722H12.3025V13.7027H18.3563C18.4712 13.7027 18.5191 13.5907 18.4233 13.5254C15.1474 11.1171 12.1205 5.57257 11.6224 1.77351L12.8006 0.980101C12.724 4.12576 15.7413 10.109 20.1379 13.2174C21.067 13.8801 20.5498 14.9722 19.6015 14.9722ZM11.8523 23.8584C9.24691 23.8584 8.82539 21.9636 7.312 21.9636C5.75063 21.9636 5.50157 23.8584 2.51305 23.8584H1.54559C1.17205 23.8584 0.86553 23.5597 0.86553 23.1957C0.86553 22.8317 1.17205 22.5423 1.54559 22.5423H2.51305C3.54753 22.5423 4.12224 22.1222 4.85028 21.6275C5.47288 21.1889 6.24875 20.6475 7.312 20.6475C8.40394 20.6475 9.18945 21.2168 9.82162 21.6742C10.473 22.1596 10.9998 22.5423 11.8523 22.5423C12.7144 22.5423 13.2412 22.1596 13.8926 21.6742C14.5248 21.2168 15.3102 20.6475 16.4022 20.6475C17.4654 20.6475 18.2413 21.1889 18.8639 21.6275C19.5919 22.1222 20.1666 22.5423 21.2011 22.5423H21.249C21.6226 22.5423 21.9195 22.8317 21.9195 23.1957C21.9195 23.5597 21.6226 23.8584 21.249 23.8584H21.2011C18.2126 23.8584 17.9635 21.9636 16.4022 21.9636C14.8888 21.9636 14.4673 23.8584 11.8523 23.8584Z"
                                          fill="black" fill-opacity="0.85" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_365_13">
                                          <rect width="22" height="24.3158" fill="white" transform="matrix(-1 0 0 1 22 0)" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </div>
                                  <div class="col-10 align-self-center text-left">
                                    <div class="px-2">
                                      <p class="mb-0 body-3-3-2">To</p>
                                      <p class="mb-0 body-2-2" v-if="data_parent.transport_route.to.selected.id">{{ data_parent.transport_route.to.selected.name }}</p>
                                      <p class="mb-0 body-2-2-1" v-else><i>{{ data_parent.transport_route.from.selected.id ? 'Select area' : 'Select the departure port first'}}</i></p>
                                    </div>
                                  </div>  
                                  <div class="col-1 align-self-center text-right">
                                    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g clip-path="url(#clip0_366_21)">
                                        <path
                                          d="M10 0.766817C10 0.301699 9.64177 0.012572 9.09491 0.012572L0.898807 0.00628662C0.35198 0.00628662 0 0.295413 0 0.760531C0 1.01195 0.113137 1.21936 0.238844 1.48334L4.16091 9.56003C4.4249 10.0943 4.66374 10.264 4.99687 10.264C5.32999 10.264 5.5751 10.0943 5.83909 9.56003L9.75489 1.48334C9.88688 1.22565 10 1.01823 10 0.766817Z"
                                          fill="black" fill-opacity="0.85" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_366_21">
                                          <rect width="10" height="10.264" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </div>
                                </div>
                              </template>
    
                              <b-dropdown-item v-for="(area,area_i) in data_parent.transport_route.to.list" :active="area.id == data_parent.transport_route.to.selected.id" active-class="bg-green" @click="selectTransportFilter('to',area_i)" link-class="body-2-2 py-2 pl-4-5" :key="area_i">{{ area.name }}</b-dropdown-item>
                            </b-dropdown>
                          </div>
    
                          <!-- DIVIDER -->
                          <div class="col-12 my-3">
                            <div class="w-100 border-2-bottom-dashed"></div>
                          </div>
    
                          <!-- DEPARTURE -->
                          <div class="col-6 border-r-semi-grey">
                            <date-range-picker 
                              class="w-100 calendar-ticket-wrapper not-zoo" 
                              ref="departure_date" 
                              v-model="transport_date.departure"
                              opens="right" 
                              :min-date="min_date"
                              :show-dropdowns="false" 
                              :ranges="false" 
                              :single-date-picker="true" 
                              @update="updateTransportDate('departure')"
                              auto-apply>
                              <template v-slot:input="picker">
                                <div class="row no-gutters">
                                  <div class="col-1 align-self-center">
                                    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g clip-path="url(#clip0_367_25)">
                                        <path
                                          d="M3.46613 20.3442H18.5449C20.8519 20.3442 22 19.1962 22 16.9222V3.44405C22 1.1701 20.8519 0.0220795 18.5449 0.0220795H3.46613C1.15906 0.0220795 0 1.15906 0 3.44405V16.9222C0 19.2072 1.15906 20.3442 3.46613 20.3442ZM3.30055 18.5669C2.31811 18.5669 1.77722 18.0482 1.77722 17.0215V6.61213C1.77722 5.59659 2.31811 5.06673 3.30055 5.06673H18.6883C19.6708 5.06673 20.2228 5.59659 20.2228 6.61213V17.0215C20.2228 18.0482 19.6708 18.5669 18.6883 18.5669H3.30055ZM8.85298 9.0296H9.50421C9.8906 9.0296 10.012 8.91921 10.012 8.53285V7.88158C10.012 7.49522 9.8906 7.3738 9.50421 7.3738H8.85298C8.46662 7.3738 8.33416 7.49522 8.33416 7.88158V8.53285C8.33416 8.91921 8.46662 9.0296 8.85298 9.0296ZM12.5178 9.0296H13.1691C13.5554 9.0296 13.6878 8.91921 13.6878 8.53285V7.88158C13.6878 7.49522 13.5554 7.3738 13.1691 7.3738H12.5178C12.1314 7.3738 11.999 7.49522 11.999 7.88158V8.53285C11.999 8.91921 12.1314 9.0296 12.5178 9.0296ZM16.1826 9.0296H16.8339C17.2202 9.0296 17.3527 8.91921 17.3527 8.53285V7.88158C17.3527 7.49522 17.2202 7.3738 16.8339 7.3738H16.1826C15.7962 7.3738 15.6748 7.49522 15.6748 7.88158V8.53285C15.6748 8.91921 15.7962 9.0296 16.1826 9.0296ZM5.18815 12.6393H5.82839C6.22579 12.6393 6.34721 12.5289 6.34721 12.1425V11.4912C6.34721 11.1049 6.22579 10.9945 5.82839 10.9945H5.18815C4.79076 10.9945 4.66934 11.1049 4.66934 11.4912V12.1425C4.66934 12.5289 4.79076 12.6393 5.18815 12.6393ZM8.85298 12.6393H9.50421C9.8906 12.6393 10.012 12.5289 10.012 12.1425V11.4912C10.012 11.1049 9.8906 10.9945 9.50421 10.9945H8.85298C8.46662 10.9945 8.33416 11.1049 8.33416 11.4912V12.1425C8.33416 12.5289 8.46662 12.6393 8.85298 12.6393ZM12.5178 12.6393H13.1691C13.5554 12.6393 13.6878 12.5289 13.6878 12.1425V11.4912C13.6878 11.1049 13.5554 10.9945 13.1691 10.9945H12.5178C12.1314 10.9945 11.999 11.1049 11.999 11.4912V12.1425C11.999 12.5289 12.1314 12.6393 12.5178 12.6393ZM16.1826 12.6393H16.8339C17.2202 12.6393 17.3527 12.5289 17.3527 12.1425V11.4912C17.3527 11.1049 17.2202 10.9945 16.8339 10.9945H16.1826C15.7962 10.9945 15.6748 11.1049 15.6748 11.4912V12.1425C15.6748 12.5289 15.7962 12.6393 16.1826 12.6393ZM5.18815 16.2599H5.82839C6.22579 16.2599 6.34721 16.1385 6.34721 15.7522V15.1008C6.34721 14.7145 6.22579 14.6041 5.82839 14.6041H5.18815C4.79076 14.6041 4.66934 14.7145 4.66934 15.1008V15.7522C4.66934 16.1385 4.79076 16.2599 5.18815 16.2599ZM8.85298 16.2599H9.50421C9.8906 16.2599 10.012 16.1385 10.012 15.7522V15.1008C10.012 14.7145 9.8906 14.6041 9.50421 14.6041H8.85298C8.46662 14.6041 8.33416 14.7145 8.33416 15.1008V15.7522C8.33416 16.1385 8.46662 16.2599 8.85298 16.2599ZM12.5178 16.2599H13.1691C13.5554 16.2599 13.6878 16.1385 13.6878 15.7522V15.1008C13.6878 14.7145 13.5554 14.6041 13.1691 14.6041H12.5178C12.1314 14.6041 11.999 14.7145 11.999 15.1008V15.7522C11.999 16.1385 12.1314 16.2599 12.5178 16.2599Z"
                                          fill="black" fill-opacity="0.85" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_367_25">
                                          <rect width="22" height="20.3442" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </div>
                                  <div class="col-10 align-self-center text-left">
                                    <div class="px-2">
                                      <p class="mb-0 body-3-3-2">Departure</p>
                                      <p class="mb-0 body-2-2">{{ $formatDate(transport_date.departure.startDate) }}</p>
                                    </div>
                                  </div>  
                                  <div class="col-1 align-self-center text-right">
                                    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g clip-path="url(#clip0_366_21)">
                                        <path
                                          d="M10 0.766817C10 0.301699 9.64177 0.012572 9.09491 0.012572L0.898807 0.00628662C0.35198 0.00628662 0 0.295413 0 0.760531C0 1.01195 0.113137 1.21936 0.238844 1.48334L4.16091 9.56003C4.4249 10.0943 4.66374 10.264 4.99687 10.264C5.32999 10.264 5.5751 10.0943 5.83909 9.56003L9.75489 1.48334C9.88688 1.22565 10 1.01823 10 0.766817Z"
                                          fill="black" fill-opacity="0.85" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_366_21">
                                          <rect width="10" height="10.264" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </div>
                                </div>
                              </template>
                              <template #date="data">
                              <div class="calendar-ticket-item sm">
                                <p class="text-14 font-lato mb-0">
                                  {{ formatDateNumber(data.date) }}
                                </p>
                              </div>
                            </template>
                            </date-range-picker>
                          </div>
    
                          <!-- RETURN -->
                          <div class="col-6">
                            <div class="row no-gutters">
                              <div class="col-1 align-self-center">
                                <svg @click="changeTransportReturn(true)" v-if="!transport_date.is_return" class="cursor-pointer" width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <g clip-path="url(#clip0_384_29)">
                                    <path
                                      d="M2.9296 17.1764H19.0704C21.0297 17.1764 22 16.2155 22 14.2935V2.89228C22 0.970314 21.0297 0 19.0704 0H2.9296C0.979645 0 0 0.970314 0 2.89228V14.2935C0 16.2155 0.979645 17.1764 2.9296 17.1764ZM2.94826 15.6743C2.01527 15.6743 1.50212 15.1798 1.50212 14.2095V2.97625C1.50212 2.00594 2.01527 1.50212 2.94826 1.50212H19.0518C19.9754 1.50212 20.4979 2.00594 20.4979 2.97625V14.2095C20.4979 15.1798 19.9754 15.6743 19.0518 15.6743H2.94826Z"
                                      fill="#bbb" />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_384_29">
                                      <rect width="22" height="17.1764" fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                                <svg @click="changeTransportReturn(false)" v-else class="cursor-pointer" width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <g clip-path="url(#clip0_385_34)">
                                    <path
                                      d="M2.9296 17.1764H19.0704C21.0297 17.1764 22 16.2155 22 14.2935V2.89228C22 0.970314 21.0297 0 19.0704 0H2.9296C0.979645 0 0 0.970314 0 2.89228V14.2935C0 16.2155 0.979645 17.1764 2.9296 17.1764Z"
                                      class="fill-primary" />
                                    <path
                                      d="M9.96436 13.1552C9.63786 13.1552 9.38596 13.0246 9.13405 12.698L6.80153 9.82439C6.65225 9.63786 6.57761 9.43261 6.57761 9.21796C6.57761 8.79815 6.89483 8.45294 7.32401 8.45294C7.58524 8.45294 7.79984 8.53693 8.02373 8.84481L9.9271 11.2892L13.911 4.88888C14.0789 4.60899 14.3215 4.45971 14.5734 4.45971C14.9839 4.45971 15.3664 4.73961 15.3664 5.17812C15.3664 5.38338 15.2451 5.59796 15.1332 5.79389L10.7388 12.698C10.5522 13.0059 10.2816 13.1552 9.96436 13.1552Z"
                                      fill="white" />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_385_34">
                                      <rect width="22" height="17.1764" fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </div>
                              <div class="col-10 align-self-center text-left">
                                <date-range-picker 
                                  :disabled="!transport_date.is_return"
                                  class="w-100 calendar-ticket-wrapper not-zoo" 
                                  ref="departure_date" 
                                  v-model="transport_date.return"
                                  opens="right" 
                                  :min-date="transport_date.departure.startDate"
                                  :show-dropdowns="false" 
                                  :ranges="false" 
                                  :single-date-picker="true" 
                                  @update="updateTransportDate('return')"
                                  auto-apply>
                                  <template v-slot:input="picker">
                                    <div class="px-2 text-left" :class="{'opacity-05': !transport_date.is_return}">
                                      <p class="mb-0 body-3-3-2">Return</p>
                                      <p class="mb-0 body-2-2">{{ $formatDate(transport_date.return.startDate) }}</p>
                                    </div>
                                  </template>
                                  <template #date="data">
                                  <div class="calendar-ticket-item sm">
                                    <p class="text-14 font-lato mb-0">
                                      {{ formatDateNumber(data.date) }}
                                    </p>
                                  </div>
                                </template>
                                </date-range-picker>
                              </div>  
                              <div class="col-1 align-self-center text-right">
                                <svg :class="{'opacity-05': !transport_date.is_return}" width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <g clip-path="url(#clip0_366_21)">
                                    <path
                                      d="M10 0.766817C10 0.301699 9.64177 0.012572 9.09491 0.012572L0.898807 0.00628662C0.35198 0.00628662 0 0.295413 0 0.760531C0 1.01195 0.113137 1.21936 0.238844 1.48334L4.16091 9.56003C4.4249 10.0943 4.66374 10.264 4.99687 10.264C5.32999 10.264 5.5751 10.0943 5.83909 9.56003L9.75489 1.48334C9.88688 1.22565 10 1.01823 10 0.766817Z"
                                      fill="black" fill-opacity="0.85" />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_366_21">
                                      <rect width="10" height="10.264" fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </div>
                            </div>
                          </div>
  
                          <!-- DIVIDER -->
                          <div class="col-12 my-3">
                            <div class="w-100 border-2-bottom-dashed"></div>
                          </div>
    
                          <!-- BUTTON -->
                          <div class="col-12 text-right">
                            <state-button variant="primary" size="lg" :click="loadProductTransport">Search Boat</state-button>
                          </div>
                        </template>
                        <template v-else>
                          <div class="col-9">
                            <div class="row">
                              <div class="col border-r-semi-grey">
                                <p class="mb-0 body-3-3-2">From</p>
                                <p class="mb-0 body-2-2 text-truncate" v-if="data_parent.transport_route.from.selected.id">{{ data_parent.transport_route.from.selected.name }}</p>
                                <p class="mb-0 body-2-2-1" v-else><i>Select Harbor</i></p>
                                <div class="w-100 pr-2">
                                </div>
                              </div>
                              <div class="col border-r-semi-grey">
                                <p class="mb-0 body-3-3-2">To</p>
                                <p class="mb-0 body-2-2" v-if="data_parent.transport_route.to.selected.id">{{ data_parent.transport_route.to.selected.name }}</p>
                                <p class="mb-0 body-2-2-1" v-else><i>{{ data_parent.transport_route.from.selected.id ? 'Select area' : 'Select the departure port first'}}</i></p>
                              </div>
                              <div class="col border-r-semi-grey">
                                <p class="mb-0 body-3-3-2">Departure</p>
                                <p class="mb-0 body-2-2">{{ $formatDate(transport_date.departure.startDate) }}</p>
                              </div>
                              <div v-if="false" class="col border-r-semi-grey">
                                <p class="mb-0 body-3-3-2">Return</p>
                                <p class="mb-0 body-2-2">{{ $formatDate(transport_date.return.startDate) }}</p>
                              </div>
                            </div>
                          </div>
                          <div class="col-3">
                            <button class="g-btn g-btn-primary g-btn-lg w-100">Change Filter</button>
                          </div>
                        </template>
                      </div>
                    </div>  
                    <div class="w-100 p-4">
                      <b-skeleton-wrapper :loading="data_parent.product.is_load">
                        <template #loading>
                          <div class="mb-4 border-form radius-6" v-for="i in 2">
                            <div class="row">
                              <div class="col-9 align">
                                <div class="py-4 pl-4 h-100">
                                  <b-skeleton width="50%" height="27px"></b-skeleton>
                                  <div class="my-2">
                                    <b-skeleton width="30%" height="21px" class="mb-1"></b-skeleton>
                                    <b-skeleton width="70%" height="21px"></b-skeleton>
                                  </div>
                                  <b-skeleton width="20%" height="18px" class="d-table ml-auto"></b-skeleton>
                                </div>
                              </div>
                              <div class="col-3">
                                <div class="p-4 h-100 text-center bg-custom-light">
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                      
                        <div class="w-100">
                          <div class="mb-4" v-for="product in data_parent.product.list">
                            <ProductTransport :data="product" @loadProductReturn="loadProductTransport"></ProductTransport>
                          </div>
                        </div>
                      </b-skeleton-wrapper>
                    </div>
                  </template>
                </div>
                <span id="home-review"></span>
              </div>

              <!-- REVIEW -->
              <div class="w-100 pb-5" v-if="show_review">
                <div class="w-100 mb-2">
                  <p class="mb-1 heading-4-1">Reviews</p>
                  <div class="w-100 no-ws mb-4">
                    <p class="mb-0 d-inline-block align-middle mr-2"><span class="text-24 font-lato font-weight-bold">{{ data_parent.review.feedback_summary.average }}</span><span class="font-lato font-weight-bold text-16 text-semi-light"> / 5</span></p>
                    <div class="d-inline-block align-middle mr-2">
                      <star-rating 
                        :star-size="24"
                        active-color="#FED141"
                        :increment="0.1"
                        :rating="data_parent.review.feedback_summary.average"
                        read-only
                        :show-rating="false">    
                      </star-rating>
                    </div>
                    <p class="mb-0 sub-heading-1-2 text-semi-light d-inline-block align-middle">{{ data_parent.review.feedback_summary.total }} {{ $pluralWord(data_parent.review.feedback_summary.total,'review') }}</p>
                  </div>
                  <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4">
                    <div class="w-100" v-for="(review,index) in data_parent.review.all_feedback.data" :class="{'mb-4 pb-4 border-2-bottom-dashed':index+1 < data_parent.review.all_feedback.data.length}">
                      <ReviewItem :data="review"></ReviewItem>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <!-- SIDEBAR -->
          <div class="col-5">
            <div class="pl-5 ml-5 sticky" style="top:100px;">
              <b-row class="slim-grid-row" v-if="data_parent.is_load">
                <b-col cols="12" class="mb-3">
                  <b-card>
                    <b-skeleton width="50%" height="20px"></b-skeleton>
                    <b-skeleton width="70%" height="15px" class="mb-2"></b-skeleton>
                  </b-card>
                </b-col>
              </b-row>
              <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4" v-else>
                <template v-if="getTicketCart.qty == 0 && !isTicketTransportCartDeparture">
                  <div class="pb-4 mb-4 border-b-semi-grey">
                    <div class="row slim-grid-row">
                      <div class="col-6 align-self-center">
                        <p class="body-2-1 mb-0">Staring From</p>
                        <p class="mb-0 heading-4-1 text-orange font-lato">
                          {{ $formatCurrency(getMerchant.starting_price_sell) }}</p>
                        <p class="body-2-1 mb-0">per person</p>
                      </div>
                      <div class="col-6 align-self-center">
                        <button class="g-btn g-btn-lg g-btn-primary w-100" @click="checkTicketAvailability()">Check Availabilty</button>
                      </div>
                    </div>
                  </div>
                  <div class="w-100">
                    <div class="row mb-3" v-if="data_parent.opening_time.today.is_open">
                      <div class="col-1 align-self-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.0351 23.9538C18.5742 23.9538 23.9882 18.5281 23.9882 12.0007C23.9882 5.46167 18.5625 0.0476074 12.0234 0.0476074C5.49609 0.0476074 0.0820312 5.46167 0.0820312 12.0007C0.0820312 18.5281 5.50781 23.9538 12.0351 23.9538ZM12.0351 21.9617C6.50391 21.9617 2.08594 17.532 2.08594 12.0007C2.08594 6.46949 6.49219 2.0398 12.0234 2.0398C17.5547 2.0398 21.9961 6.46949 21.9961 12.0007C21.9961 17.532 17.5664 21.9617 12.0351 21.9617Z" fill="black" fill-opacity="0.85"/>
                          <path d="M5.90625 13.2664H12.0234C12.4804 13.2664 12.8437 12.9148 12.8437 12.446V4.54761C12.8437 4.09058 12.4804 3.73902 12.0234 3.73902C11.5664 3.73902 11.2148 4.09058 11.2148 4.54761V11.6374H5.90625C5.4375 11.6374 5.08594 11.989 5.08594 12.446C5.08594 12.9148 5.4375 13.2664 5.90625 13.2664Z" fill="black" fill-opacity="0.85"/>
                        </svg>
                      </div>
                      <div class="col-11 align-self-center">
                        <p class="body-2-1 mb-0" v-if="getMerchant.use_daily_operational_hour">Opening hours today : {{ data_parent.opening_time.today.operational_hour.start }} - {{ data_parent.opening_time.today.operational_hour.end }}</p>
                        <p class="body-2-1 mb-0" v-else>Opening hours today : {{ formatHour(getMerchant.time_start) }} - {{ formatHour(getMerchant.time_end) }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-1 align-self-start">
                        <svg v-if="data_parent.opening_time.today.is_open" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_246_8)">
                            <path
                              d="M3.67969 25.4062H19.6875C22.1367 25.4062 23.3555 24.1875 23.3555 21.7734V7.46484C23.3555 5.05078 22.1367 3.83203 19.6875 3.83203H3.67969C1.23047 3.83203 0 5.03906 0 7.46484V21.7734C0 24.1992 1.23047 25.4062 3.67969 25.4062ZM3.50391 23.5195C2.46094 23.5195 1.88672 22.9688 1.88672 21.8789V10.8281C1.88672 9.75 2.46094 9.1875 3.50391 9.1875H19.8398C20.8828 9.1875 21.4688 9.75 21.4688 10.8281V21.8789C21.4688 22.9688 20.8828 23.5195 19.8398 23.5195H3.50391Z"
                              fill="black" fill-opacity="0.85" />
                            <path
                              d="M9.39844 13.3945H10.0898C10.5 13.3945 10.6289 13.2773 10.6289 12.8672V12.1758C10.6289 11.7656 10.5 11.6367 10.0898 11.6367H9.39844C8.98828 11.6367 8.84766 11.7656 8.84766 12.1758V12.8672C8.84766 13.2773 8.98828 13.3945 9.39844 13.3945ZM13.2891 13.3945H13.9805C14.3906 13.3945 14.5312 13.2773 14.5312 12.8672V12.1758C14.5312 11.7656 14.3906 11.6367 13.9805 11.6367H13.2891C12.8789 11.6367 12.7383 11.7656 12.7383 12.1758V12.8672C12.7383 13.2773 12.8789 13.3945 13.2891 13.3945ZM17.1797 13.3945H17.8711C18.2812 13.3945 18.4219 13.2773 18.4219 12.8672V12.1758C18.4219 11.7656 18.2812 11.6367 17.8711 11.6367H17.1797C16.7695 11.6367 16.6406 11.7656 16.6406 12.1758V12.8672C16.6406 13.2773 16.7695 13.3945 17.1797 13.3945ZM5.50781 17.2266H6.1875C6.60938 17.2266 6.73828 17.1094 6.73828 16.6992V16.0078C6.73828 15.5977 6.60938 15.4805 6.1875 15.4805H5.50781C5.08594 15.4805 4.95703 15.5977 4.95703 16.0078V16.6992C4.95703 17.1094 5.08594 17.2266 5.50781 17.2266ZM9.39844 17.2266H10.0898C10.5 17.2266 10.6289 17.1094 10.6289 16.6992V16.0078C10.6289 15.5977 10.5 15.4805 10.0898 15.4805H9.39844C8.98828 15.4805 8.84766 15.5977 8.84766 16.0078V16.6992C8.84766 17.1094 8.98828 17.2266 9.39844 17.2266ZM13.2891 17.2266H13.9805C14.3906 17.2266 14.5312 17.1094 14.5312 16.6992V16.0078C14.5312 15.5977 14.3906 15.4805 13.9805 15.4805H13.2891C12.8789 15.4805 12.7383 15.5977 12.7383 16.0078V16.6992C12.7383 17.1094 12.8789 17.2266 13.2891 17.2266ZM5.50781 21.0703H6.1875C6.60938 21.0703 6.73828 20.9414 6.73828 20.5312V19.8398C6.73828 19.4297 6.60938 19.3125 6.1875 19.3125H5.50781C5.08594 19.3125 4.95703 19.4297 4.95703 19.8398V20.5312C4.95703 20.9414 5.08594 21.0703 5.50781 21.0703ZM9.39844 21.0703H10.0898C10.5 21.0703 10.6289 20.9414 10.6289 20.5312V19.8398C10.6289 19.4297 10.5 19.3125 10.0898 19.3125H9.39844C8.98828 19.3125 8.84766 19.4297 8.84766 19.8398V20.5312C8.84766 20.9414 8.98828 21.0703 9.39844 21.0703ZM13.2891 21.0703H13.9805C14.3906 21.0703 14.5312 20.9414 14.5312 20.5312V19.8398C14.5312 19.4297 14.3906 19.3125 13.9805 19.3125H13.2891C12.8789 19.3125 12.7383 19.4297 12.7383 19.8398V20.5312C12.7383 20.9414 12.8789 21.0703 13.2891 21.0703Z"
                              fill="black" fill-opacity="0.85" />
                            <path
                              d="M22.4297 29.2148C26.543 29.2148 29.9766 25.7812 29.9766 21.6562C29.9766 17.5078 26.5781 14.0977 22.4297 14.0977C18.2812 14.0977 14.8711 17.5195 14.8711 21.6562C14.8711 25.8164 18.2695 29.2148 22.4297 29.2148Z"
                              fill="white" />
                            <path
                              d="M22.4297 27.6094C25.6523 27.6094 28.3828 24.9141 28.3828 21.6562C28.3828 18.3867 25.6875 15.7031 22.4297 15.7031C19.1602 15.7031 16.4766 18.3984 16.4766 21.6562C16.4766 24.9375 19.1602 27.6094 22.4297 27.6094Z"
                              class="fill-primary" />
                            <path
                              d="M21.7148 24.8672C21.5156 24.8672 21.2812 24.7852 21.1289 24.6211L19.1484 22.4414C19.0078 22.2891 18.9492 22.0781 18.9492 21.9141C18.9492 21.4922 19.2773 21.1758 19.6875 21.1758C19.9336 21.1758 20.1211 21.293 20.2383 21.4219L21.6797 22.9805L24.5391 19.0195C24.6797 18.832 24.8906 18.6914 25.1602 18.6914C25.5469 18.6914 25.8984 19.0078 25.8984 19.418C25.8984 19.5469 25.8398 19.7109 25.7344 19.8633L22.3359 24.5859C22.207 24.7617 21.9727 24.8672 21.7148 24.8672Z"
                              fill="white" />
                          </g>
                          <defs>
                            <clipPath id="clip0_246_8">
                              <rect width="29.9766" height="29.2148" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <svg v-else width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_248_16)">
                            <path
                              d="M3.67969 25.4062H19.6875C22.1367 25.4062 23.3555 24.1875 23.3555 21.7734V7.46484C23.3555 5.05078 22.1367 3.83203 19.6875 3.83203H3.67969C1.23047 3.83203 0 5.03906 0 7.46484V21.7734C0 24.1992 1.23047 25.4062 3.67969 25.4062ZM3.50391 23.5195C2.46094 23.5195 1.88672 22.9688 1.88672 21.8789V10.8281C1.88672 9.75 2.46094 9.1875 3.50391 9.1875H19.8398C20.8828 9.1875 21.4688 9.75 21.4688 10.8281V21.8789C21.4688 22.9688 20.8828 23.5195 19.8398 23.5195H3.50391Z"
                              fill="black" fill-opacity="0.85" />
                            <path
                              d="M9.39844 13.3945H10.0898C10.5 13.3945 10.6289 13.2773 10.6289 12.8672V12.1758C10.6289 11.7656 10.5 11.6367 10.0898 11.6367H9.39844C8.98828 11.6367 8.84766 11.7656 8.84766 12.1758V12.8672C8.84766 13.2773 8.98828 13.3945 9.39844 13.3945ZM13.2891 13.3945H13.9805C14.3906 13.3945 14.5312 13.2773 14.5312 12.8672V12.1758C14.5312 11.7656 14.3906 11.6367 13.9805 11.6367H13.2891C12.8789 11.6367 12.7383 11.7656 12.7383 12.1758V12.8672C12.7383 13.2773 12.8789 13.3945 13.2891 13.3945ZM17.1797 13.3945H17.8711C18.2812 13.3945 18.4219 13.2773 18.4219 12.8672V12.1758C18.4219 11.7656 18.2812 11.6367 17.8711 11.6367H17.1797C16.7695 11.6367 16.6406 11.7656 16.6406 12.1758V12.8672C16.6406 13.2773 16.7695 13.3945 17.1797 13.3945ZM5.50781 17.2266H6.1875C6.60938 17.2266 6.73828 17.1094 6.73828 16.6992V16.0078C6.73828 15.5977 6.60938 15.4805 6.1875 15.4805H5.50781C5.08594 15.4805 4.95703 15.5977 4.95703 16.0078V16.6992C4.95703 17.1094 5.08594 17.2266 5.50781 17.2266ZM9.39844 17.2266H10.0898C10.5 17.2266 10.6289 17.1094 10.6289 16.6992V16.0078C10.6289 15.5977 10.5 15.4805 10.0898 15.4805H9.39844C8.98828 15.4805 8.84766 15.5977 8.84766 16.0078V16.6992C8.84766 17.1094 8.98828 17.2266 9.39844 17.2266ZM13.2891 17.2266H13.9805C14.3906 17.2266 14.5312 17.1094 14.5312 16.6992V16.0078C14.5312 15.5977 14.3906 15.4805 13.9805 15.4805H13.2891C12.8789 15.4805 12.7383 15.5977 12.7383 16.0078V16.6992C12.7383 17.1094 12.8789 17.2266 13.2891 17.2266ZM5.50781 21.0703H6.1875C6.60938 21.0703 6.73828 20.9414 6.73828 20.5312V19.8398C6.73828 19.4297 6.60938 19.3125 6.1875 19.3125H5.50781C5.08594 19.3125 4.95703 19.4297 4.95703 19.8398V20.5312C4.95703 20.9414 5.08594 21.0703 5.50781 21.0703ZM9.39844 21.0703H10.0898C10.5 21.0703 10.6289 20.9414 10.6289 20.5312V19.8398C10.6289 19.4297 10.5 19.3125 10.0898 19.3125H9.39844C8.98828 19.3125 8.84766 19.4297 8.84766 19.8398V20.5312C8.84766 20.9414 8.98828 21.0703 9.39844 21.0703ZM13.2891 21.0703H13.9805C14.3906 21.0703 14.5312 20.9414 14.5312 20.5312V19.8398C14.5312 19.4297 14.3906 19.3125 13.9805 19.3125H13.2891C12.8789 19.3125 12.7383 19.4297 12.7383 19.8398V20.5312C12.7383 20.9414 12.8789 21.0703 13.2891 21.0703Z"
                              fill="black" fill-opacity="0.85" />
                            <path
                              d="M22.4297 29.2148C26.543 29.2148 29.9766 25.7812 29.9766 21.6562C29.9766 17.5078 26.5781 14.0977 22.4297 14.0977C18.2812 14.0977 14.8711 17.5195 14.8711 21.6562C14.8711 25.8164 18.2695 29.2148 22.4297 29.2148Z"
                              fill="white" />
                            <path
                              d="M22.4297 27.6094C25.6523 27.6094 28.3828 24.9141 28.3828 21.6562C28.3828 18.3867 25.6875 15.7031 22.4297 15.7031C19.1602 15.7031 16.4766 18.3984 16.4766 21.6562C16.4766 24.9375 19.1602 27.6094 22.4297 27.6094Z"
                              class="fill-danger" />
                            <path
                              d="M19.418 22.3711C19.0195 22.3711 18.6914 22.0312 18.6914 21.6562C18.6914 21.2812 19.0195 20.9414 19.418 20.9414H25.4414C25.8281 20.9414 26.1562 21.2812 26.1562 21.6562C26.1562 22.0312 25.8281 22.3711 25.4414 22.3711H19.418Z"
                              fill="white" />
                          </g>
                          <defs>
                            <clipPath id="clip0_248_16">
                              <rect width="29.9766" height="29.2148" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div class="col-11 align-self-start no-ws pt-1">
                        <p class="body-2-1 mb-0 d-inline-block align-middle mr-2">{{ data_parent.opening_time.today.is_open ? 'Available Today' : 'Today is closed' }}</p>
                        <p class="mb-0 overline text-orange cursor-pointer d-inline-block align-middle" v-b-toggle.opening_day>(See all opening days)</p>
                        <b-collapse id="opening_day" class="mt-3">
                          <div class="row no-gutters mb-3" v-for="open_day in data_parent.opening_time.all_day">
                            <div class="col-1 align-self-center">
                              <svg v-if="open_day.is_open" width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.21184 11.664L1.73088 7.18301L0.204987 8.69816L6.21184 14.705L19.1067 1.81016L17.5915 0.295013L6.21184 11.664Z" fill="#28A745"/>
                              </svg>
                              <svg v-else class="lh-1" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#DC3545"/>
                              </svg>
                            </div>
                            <div class="col-10 align-self-center">
                              <p class="body-2-2 mb-0" :class="{'font-weight-bold': data_parent.opening_time.today.day == open_day.day}" v-if="!getMerchant.use_daily_operational_hour">{{ open_day.day }}</p>
                              <div class="row" v-else>
                                <div class="col-4">
                                  <p class="body-2-2 mb-0" :class="{'font-weight-bold': data_parent.opening_time.today.day == open_day.day}">{{ open_day.day }}</p>
                                </div>  
                                <div class="col-8">
                                  <template v-if="open_day.is_open">
                                    <p class="body-2-2 mb-0" :class="{'font-weight-bold': data_parent.opening_time.today.day == open_day.day}">{{ open_day.operational_hour.start }} - {{ open_day.operational_hour.end }}</p>
                                  </template>
                                  <p v-else class="body-2-2 mb-0 text-danger">Closed</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </b-collapse>
                      </div>
                    </div>
                  </div>
                </template>
                <div class="w-100" v-if="getTicketCart.qty > 0 || isTicketTransportCartDeparture">
                  <div class="w-100 mb-4 pb-4 border-2-bottom-dashed">
                    <p class="mb-0 heading-4-1">Booking Summary</p>
                  </div>
                  
                  <!-- PRODUCT SELECTED -->
                  <div class="w-100 mb-4 pb-3 border-b-semi-grey" v-if="getMerchant.merchant_category_name == 'ACTIVITIES'">
                    <div class="row mb-3" v-for="cart in getTicketCart.ticket_details">
                      <div class="col-8">
                        <p class="mb-0 body-1-4">{{ cart.ticket.name }}</p>
                        <ul class="pl-3">
                          <li v-for="variant in cart.variant">
                            <p class="body-2-1 mb-0">{{variant.data.variant_name}} - {{ $formatCurrency(variant.data.best_price.best_price.final_price) }} x {{ variant.qty }}</p>
                          </li>
                        </ul>
                      </div>
                      <div class="col-4 text-right">
                        <p class="text-16 font-lato mb-0">{{ $formatCurrency(printTotalPriceSelected(cart)) }}</p>
                          <div class="d-table ml-auto cursor-pointer" @click="removeProductCart(cart)">
                            <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_201_6878)">
                                <path
                                  d="M4.41081 12.7934C4.15135 12.7934 3.98503 12.6403 3.97172 12.3875L3.77214 5.06279C3.76549 4.81663 3.93181 4.65696 4.19792 4.65696C4.44407 4.65696 4.61705 4.80998 4.6237 5.05613L4.83659 12.3875C4.84324 12.6337 4.67027 12.7934 4.41081 12.7934ZM6.43994 12.7934C6.18045 12.7934 6.00082 12.6337 6.00082 12.3875V5.06279C6.00082 4.81663 6.18045 4.65696 6.43994 4.65696C6.69939 4.65696 6.88565 4.81663 6.88565 5.06279V12.3875C6.88565 12.6337 6.69939 12.7934 6.43994 12.7934ZM8.47568 12.7934C8.21624 12.7934 8.04326 12.6337 8.0499 12.3875L8.25615 5.06279C8.26279 4.80998 8.43577 4.65696 8.68193 4.65696C8.94801 4.65696 9.11435 4.81663 9.10771 5.06279L8.9081 12.3875C8.89482 12.6403 8.72848 12.7934 8.47568 12.7934ZM3.51934 3.04033H4.57713V1.61663C4.57713 1.23742 4.84324 0.991266 5.24241 0.991266H7.62412C8.02328 0.991266 8.28942 1.23742 8.28942 1.61663V3.04033H9.34717V1.5501C9.34717 0.585447 8.72184 0 7.6973 0H5.16923C4.1447 0 3.51934 0.585447 3.51934 1.5501V3.04033ZM0.49896 3.57256H12.3875C12.6603 3.57256 12.8798 3.33971 12.8798 3.06694C12.8798 2.79418 12.6603 2.56798 12.3875 2.56798H0.49896C0.232848 2.56798 0 2.79418 0 3.06694C0 3.34636 0.232848 3.57256 0.49896 3.57256ZM3.39293 14.8158H9.49358C10.4449 14.8158 11.0836 14.1971 11.1302 13.2457L11.5959 3.43285H1.28399L1.75634 13.2524C1.80291 14.2037 2.42827 14.8158 3.39293 14.8158Z"
                                  fill="#DC3545" />
                              </g>
                              <defs>
                                <clipPath id="clip0_201_6878">
                                  <rect width="12.8798" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="w-100 mb-4 pb-3 border-b-semi-grey" v-else>
                    <div class="row mb-3">
                      <div class="col-8">
                        <p class="mb-0 body-1-4">{{ product_transport_cart.departure.variant[0].data.route_from.name }} - {{ product_transport_cart.departure.variant[0].data.route_to.name }}</p>
                        <p class="body-2-1 mb-0" v-for="variant in product_transport_cart.departure.variant">{{variant.data.variant_name}} - {{ $formatCurrency(variant.data.price_sell_discount) }} x {{ variant.qty }}</p>
                      </div>
                      <div class="col-4 text-right">
                        <p class="body-2-1 mb-0">{{ product_transport_cart.departure.product.name }}</p>
                        <p class="text-16 font-lato mb-0">{{ $formatCurrency(printTotalPriceSelected(product_transport_cart.departure)) }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- PROMO CODE -->
                  <div class="w-100 mb-4 pb-4 border-b-semi-grey">
                    <div class="row slim-grid-row">
                      <div class="col-12">
                        <p class="body-1-4">{{ $t('ticket.enter-promo-code') }}</p>
                      </div>
                      <div class="col-7">
                        <div class="w-100 border-secondary-t radius-6 position-relative" :class="promo_code.error != '' ? 'shake-el border-danger' : ''" style="padding-block: 12.3px;">
                          <input :disabled="promo_code.is_load" type="text" class="w-100 no-focus-border border-none body-1-4 radius-6 text-ticket pl-3 pr-5" v-model="promo_code.form" @keyup.enter="$refs.btn_promo.handleClick()">
                          <div v-if="promo_code.form != ''" class="position-absolute cursor-pointer" @click="clearPromoCode" style="top: 10px;right:10px;">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M0.221622 13.3683C0.521384 13.6596 1.01813 13.6596 1.30933 13.3683L6.7907 7.88694L12.2721 13.3683C12.5633 13.6596 13.0686 13.6681 13.3598 13.3683C13.651 13.0686 13.651 12.5804 13.3598 12.2892L7.87841 6.79924L13.3598 1.31787C13.651 1.02667 13.6596 0.529924 13.3598 0.238726C13.06 -0.0610364 12.5633 -0.0610364 12.2721 0.238726L6.7907 5.7201L1.30933 0.238726C1.01813 -0.0610364 0.512819 -0.069601 0.221622 0.238726C-0.0695761 0.538488 -0.0695761 1.02667 0.221622 1.31787L5.70299 6.79924L0.221622 12.2892C-0.0695761 12.5804 -0.078141 13.0771 0.221622 13.3683Z"
                                fill="#777777" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <state-button ref="btn_promo" variant="primary" block :click="applyPromo" size="lg"><span class="text-uppercase">{{ $t('ticket.apply') }}</span></state-button>
                      </div>
                      <div v-if="promo_code.error != ''" class="col-12 mt-1">
                        <p class="body-3-3 mb-0 text-danger">{{promo_code.error}}</p>
                      </div>
                    </div>
                  </div>

                  <div class="w-100">
                    <div class="row mb-3">
                      <div class="col-6">
                        <p class="mb-0 body-1-4">Subtotal</p>
                      </div>
                      <div class="col-6 text-right">
                        <p class="text-16 font-lato mb-0">{{ $formatCurrency(getTicketSubTotalPrice) }}</p>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-6">
                        <p class="mb-0 body-1-4">Discount</p>
                      </div>
                      <div class="col-6 text-right">
                        <p class="text-16 font-lato mb-0" :class="{
                          'text-green': getTicketDiscountPrice > 0
                        }">{{getTicketDiscountPrice > 0? '-' : ''}}{{ $formatCurrency(getTicketDiscountPrice) }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <p class="mb-0 heading-6-1">Total</p>
                      </div>
                      <div class="col-6 text-right">
                        <p class="text-20 font-lato mb-0">{{ $formatCurrency(getTicketTotalPrice) }}</p>
                      </div>
                      <div class="col-12 mt-4">
                        <button class="g-btn g-btn-primary-outline g-btn-lg w-100" @click="goToBookingCart">Proceed Booking</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer v-if="!data_parent.is_load"></Footer>
  </div>
</template>

<script>
  import {
    mapActions,
    mapGetters,
    mapMutations
  } from 'vuex';
  import moment from 'moment';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
  import Flickity from 'vue-flickity';
  import Product from '../../components/ticket/Product'
  import ProductTransport from '../../components/ticket/productTransport'
  import DateRangePicker from 'vue2-daterange-picker';
  import CoolLightBox from 'vue-cool-lightbox'
  import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
  import Footer from '../../components/ticket/Footer';
  import Header from '../../components/ticket/Header';
  import ReviewItem from '../../components/ticket/ReviewItem';

  export default {
    props: ['data_parent','load_product','load_product_transport'],
    components: {
      Flickity,
      DateRangePicker,
      Product,
      CoolLightBox,
      Footer,
      Header,
      ReviewItem,
      ProductTransport
    },
    data() {
      return {
        map: {
          center: {
            lat: null,
            lng: null
          },
          markers: []
        },
        visit_date:{
          startDate: moment().toDate(),
	        endDate: moment().toDate()
        },
        min_date: moment().toDate(),
        active_image: null,
        promo_code:{
          form: '',
          error: '',
          is_load: false,
          valid: ''
        },
        minimize_transport_filter: true,
        product_special_selected: {},
        transport_date: {
          departure:{
            startDate: moment().toDate()
          },
          is_return: false,
          return:{
            startDate: moment().toDate()
          }
        }
      }
    },
    computed: {
      ...mapGetters(['getMerchant','getTicketCart','getTicketCartSubTotal','getTicketSubTotalPrice','getTicketDiscountPrice','getTicketTotalPrice','isTicketTransportCartDeparture','getTicketTransportCart']),
      visit_date_start(){
        return this.visit_date.startDate
      },
      is_product_load(){
        return this.data_parent.product.is_load
      },
      promo_code_vuex(){
        return this.getTicketCart.promo_code
      },
      return_date_parent(){
        return this.$formatDate(this.data_parent.transport_date.return.startDate)
      },
      show_review(){
        let return_data = false
        if(!this.$isObjectEmpty(this.data_parent.review) && this.data_parent.review.all_feedback.data.length > 0) return_data = true
        return return_data
      },
      product_transport_cart(){
        let data = {
          departure: {},
          return: {}
        }
        if(this.isTicketTransportCartDeparture){
          data.departure = this.getTicketTransportCart.departure
          data.return = this.getTicketTransportCart.return
        }  
        return data
      }
    },
    watch:{
      visit_date_start(){
        if(!this.data_parent.product.is_load){
          this.ticketSetBookingDateCart(this.visit_date_start)
          this.loadProduct()
        }
      },
      is_product_load(){
        if(!this.is_product_load){
          this.visit_date.startDate = this.getTicketCart.visit_date
        }
      },
      promo_code_vuex(){
        this.promo_code.form = this.getTicketCart.promo_code
      },
      return_date_parent(){
        this.transport_date.return.startDate = this.data_parent.transport_date.return.startDate
        this.transport_date.return.endDate = this.data_parent.transport_date.return.startDate
      }
    },
    mounted() {
      this.map.center = {
        lat: this.getMerchant.lat,
        lng: this.getMerchant.lng
      }
      this.map.markers = []
      this.map.markers.push({
        position: this.map.center
      });
      this.visit_date.startDate = this.getTicketCart.visit_date
      this.promo_code.form = this.getTicketCart.promo_code
      this.transport_date = this.$deepCopy(this.data_parent.transport_date)
    },
    methods: {
      ...mapActions(['ticketResetItemCart','ticketSetBookingDateCart','ticketClearItemCart']),
      ...mapMutations(['ticketSetPromoCode','resetTicketTransport']),
      formatDateNumber(value){
	      return moment(value).format("D")
	    },
      formatHour(time){
        return moment(time, 'HH:mm:ss').format('hh:mm A')
      },
      loadProduct(){
        this.ticketResetItemCart()
        this.load_product(true,this.promo_code_vuex)
      },
      checkTicketAvailability(){
        this.$smoothScroll('ticket-option')
      },
      printTotalPriceSelected(data){
        let total = 0
        data.variant.forEach(item=>{
          let price = this.getMerchant.merchant_category_name == 'ACTIVITIES' ? item.data.best_price.best_price.final_price : item.data.price_sell_discount
          
          total += (price*item.qty) 
        })
        return total
      },
      removeProductCart(data){
        this.ticketClearItemCart(data.ticket)
      },
      setActiveImage(index){
        this.active_image = index
      },
      goToBookingCart(){
        this.$router.push(`/${this.getMerchant.code}/cart`)
      },
      clearPromoCode(){
        this.promo_code.form = ''
        this.promo_code.error = ''
        if(this.promo_code_vuex != ''){
          this.ticketSetPromoCode('')
          this.applyPromo(true)
        }
      },
      applyPromo(is_clear=false){
        return new Promise((success,fail)=>{
          if(this.promo_code.form == '' && !is_clear){
            this.promo_code.error = 'Promo code is empty'
            success()
          }else{
            this.promo_code.is_load = true
            this.promo_code.error = ''
            this.load_product(false,this.promo_code.form)
            .then(res=>{
              if(typeof res == 'string') {
                this.promo_code.error = res == 'promo_code not found' ? 'Promo code not available' : res
              } else {
                this.ticketSetPromoCode(this.promo_code.form)
              }
            })
            .finally(()=>{
              this.promo_code.is_load = false
              success()
            })
          }
        })
      },
      toggleProductSpecial(data={}){
        let new_data = {}
        if(this.product_special_selected.id != data.id) new_data = data
        this.product_special_selected = new_data
        this.$emit('productSpecialSelected',new_data)
      },
      updateProductSpecialSelected(data){
        this.product_special_selected = data
      },
      shareClick(){
        let value = window.location.href;
        this.$copyText(value,'Successfully copy the url')
      },
      selectTransportFilter(type,parent_index,child_index){
        this.$emit('selectTransportFilter',{
          type: type,
          data: {
            parent: parent_index,
            child: child_index
          }
        })
      },
      toggleDDTo(){
        requestAnimationFrame(() => {
          this.$refs.filter_to.show()
        })
      },
      changeTransportReturn(data){
        this.transport_date.is_return = data
        this.updateTransportDate('is_return')
      },
      updateTransportDate(type){
        let data = null
        if(type == 'departure') data = this.transport_date.departure.startDate
        else if(type == 'is_return') data = this.transport_date.is_return
        else if(type == 'return') data = this.transport_date.return.startDate
        this.$emit("updateTransportDate",{
          type: type,
          data: data
        })
      },
      loadProductTransport(is_return=false){
        return new Promise((success,fail)=>{
          this.minimize_transport_filter = true
          if(!is_return){
            this.resetTicketTransport('departure')
          }
          this.load_product_transport(is_return).finally(()=>{
            success()
          })
        })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/ticket/TicketHomePageDesktop.vue